import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL} from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
    setOutputConfigHistoryLogsLoading ,
    getOutputConfigHistoryLogs ,
    setOutputConfigHistoryPageSize,
    resetOutputConfigHistory,
    setOutputConfigHistoryColSearchStr
} from '../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-history.settings';


const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const outputConfigHistoryActions = {

    getOutputConfigHistoryLogs: (outputConfigId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().outputConfigHistory.HistoryTable;
        var formData = {
            OutputConfigurationId: outputConfigId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,

        };

        dispatch({
            type: setOutputConfigHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/recharge/getOutputConfigHistoryLogs', formData);

        dispatch({
            type: getOutputConfigHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeOutputConfigHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setOutputConfigHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    setOutputConfigHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().outputConfigHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setOutputConfigHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },

    resetOutputConfigHistory: () => (dispatch, state) => {
        dispatch({
            type: resetOutputConfigHistory
        })
    },

    extractOutputConfigHistoryLogs: (outputConfigurationId) => async (dispatch, state) => {
        const { Headers } = state().outputConfigHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Output Configuration History – ${formattedTimeZoneDate}`;

        var formData = {
            OutputConfigurationId: outputConfigurationId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/recharge/getExtractOutputConfigHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setOutputConfigHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getOutputConfigHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setOutputConfigHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setOutputConfigHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetOutputConfigHistory:
            return initialState;
        default:
            return state;
    }
}